module.exports = __webpack_public_path__ + "img/accessories-4.eee28fa.webp";